import { render } from "./Dashboard-EIS-Daerah.vue?vue&type=template&id=58c3cd23"
import script from "./Dashboard-EIS-Daerah.vue?vue&type=script&lang=js"
export * from "./Dashboard-EIS-Daerah.vue?vue&type=script&lang=js"

import "./Dashboard-EIS-Daerah.vue?vue&type=style&index=0&id=58c3cd23&lang=css"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__